module.exports = __webpack_public_path__ + "img/menuDetail8.26e76c03.png";